<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="./../assets/imgs/74/title-bg.png" alt="" />
      <div class="technological-process">
        <div class="rhtj mar-t2">
          <img class="top" src="./../assets/imgs/70/title-1.png" alt="" />
          <div class="content">
            <div class="font" style="marginBottom: 0.1rem">
              （一）税收和相关经济数据统计关系在锦江区的企事业单位、社会组织以及在锦江区创新创业的各类人才。
            </div>
          </div>
          <div class="content">
            <div class="font">
              （二）申报单位或人才近三年未发生重大安全生产及环境保护事故、重大违法行为，未被纳入失信被执行名单。
            </div>
          </div>
        </div>
        <div class="zccl">
            <img
                class="top"
                src="./../assets/imgs/74/title-2.png"
                alt=""
            />
            
            <div class="content">
              <div class="topFont">对成功引进或培育市级及以上人才计划专家的招才引智顾问、人力资源服务机构和用人单位。</div>
                <div class="des">
                    <div class="title">一、引才奖励</div>
                    帮助或自主从锦江区外引进已入选国家级、省级和市级人才计划专家人才的招才引智顾问、人力资源服务机构或用人单位。或近年来帮助企业或自主引进的专家人才，入选了国家、四川省、成都市引才计划的招才引智顾问、人力资源服务机构或用人单位。
                </div>
                <div class="des">
                    <div class="title">二、协同引才奖励</div>
                    帮助或自主从锦江区外引进已入选国家级、省级和市级人才计划的专家人才作为主要创始人（持股比例不少于30%），带项目、带资金在锦江区创办企业（实缴资本500万元以上）的招才引智顾问、人力资源服务机构或用人单位。或近年来帮助区域引进或自主落户的专家人才，作为主要创始人带项目、带资金在锦江区创办企业，入选国家、四川省、成都市引才计划创业项目的招才引智顾问、人力资源服务机构或创业企业。
                </div>
                <div class="des">
                    <div class="title">三、育才奖励</div>
                    帮助或自主从锦江区外引进已入选国家级、省级和市级人才计划的专家人才作为主要创始人（持股比例不少于30%），带项目、带资金在锦江区创办企业（实缴资本500万元以上）的招才引智顾问、人力资源服务机构或用人单位。或近年来帮助区域引进或自主落户的专家人才，作为主要创始人带项目、带资金在锦江区创办企业，入选国家、四川省、成都市引才计划创业项目的招才引智顾问、人力资源服务机构或创业企业。
                </div>
            </div>
        </div>
        <div class="rhtj mar-t2">
          <img class="top" src="./../assets/imgs/74/title-3.png" alt="" />
          <div class="content">
            <div class="font" style="marginBottom: 0.1rem">
              （一）引进国际顶尖人才，给予20万元/名的奖励；引进国家级领军人才给予15万元/名的奖励；引进地方高级人才，给予10万元/名的奖励。
            </div>
          </div>
          <div class="content">
            <div class="font" style="marginBottom: 0.1rem">
              （二）对所引进人才获得引才奖励，并作为主要创始人带项目、带资金到锦江区创办企业，注册资本金实缴500万元以上的，额外给予最高5万元的协同引才奖励。注册资本实缴1亿元以上的，额外给予“锦城伯乐”协同引才奖励50万元。
            </div>
          </div>
          <div class="content">
            <div class="font" >
              （三）培育国际顶尖人才、国家级领军人才，给予10万元/名奖励。培育地方高级人才，给予5万元/名奖励。
            </div>
          </div>
        </div>
        
        <div class="sbcl">
          <img class="top" src="./../assets/imgs/70/title-4.png" alt="" />
          <div class="content">
            <div class="des">
              <div class="item">
                <div class="dot">1</div>
                《锦江区“锦城伯乐”引才育才奖励申请表》（见附件8）；
              </div>
              <div class="item">
                <div class="dot">2</div>
                申请单位为招才引智顾问（个人）的，提供个人身份证复印件，委托协议等；申请单位为人力资源服务机构的，提供统一社会信用代码复印件，合作协议等。
              </div>
              <div class="item">
                <div class="dot">3</div>
                引进（培育）人才所在单位统一社会信用代码复印件；
              </div>
              <div class="item">
                <div class="dot">4</div>
                引进（培育）人才所在单位纳税证明；
              </div>
              <div class="item">
                <div class="dot">5</div>
                引进（培育）人才劳动合同复印件（公司任职文件）；
              </div>
              <div class="item">
                <div class="dot">6</div>
                引进（培育）人才个人身份证（护照）复印件；
              </div>
              <div class="item">
                <div class="dot">7</div>
                引进（培育）人才入选人才项目证明，包括但不限于入选文件、证书等复印件；
              </div>
              <div class="item">
                <div class="dot">8</div>
                引进（培育）人才社保缴纳证明；
              </div>
              <div class="item">
                <div class="dot">9</div>
                引进（培育）人才个税缴纳证明。
              </div>
              <div class="item">
                <div class="dot">10</div>
                申请协同引才奖励的还需提供创办企业证明材料，包括但不限于企业统一社会信用代码复印件、企业纳税证明、加盖工商鲜章的公司章程、商业计划书、盖有会计师事务所公章的公司验资报告或审计报告（资产负债表）、上年度企业财务报表等；
              </div>
              <div class="item">
                <div class="dot">11</div>
                诚信申报承诺书。
              </div>
            </div>
          </div>
        </div>
        <div class="contact">
          <img class="top" src="./../assets/imgs/70/title-5.png" alt="" />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-86624369">028-86624369</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              区委组织部（区委人才办）
            </div>
          </div>
        </div>
        <div class="codes">
          <img class="code" src="../assets/imgs/70/code.png" />
          <img class="text" src="../assets/imgs/70/text.png" />
        </div>
      </div>
    </section>
    <!-- <call phone="028-83221725"></call> -->
  </div>
</template>

<script>
import call from "../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.xlrclh {
  background-color: $base-back;

  .top-img {
    width: 7.26rem;
    height: 5.6rem;
  }
  .technological-process {
    transform: translateY(-2.1rem);
    .rhtj {
      position: relative;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #d4e0ff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        font-size: 0.26rem;
        font-weight: 500;
        color: #4e4e4e;
        text-align: left;
        line-height: 0.44rem;
        .font {
          background-color: #fff;
          border-radius: 0.2rem;
          padding: 0.28rem 0.31rem;
        }
      }
    }

    .sxcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        padding: 0.54rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;
      }
    }
    .zccl {
            position: relative;
            margin-top: 0.22rem;
            font-size: 0.26rem;
            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }
            
            .content {
                width: 6.85rem;
                background: #D4E0FF;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                .topFont{
                  margin-top: 0.1rem;
                  line-height: 0.44rem;
                }
                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.8rem;
                    position: relative;
                    text-align: left;
                    line-height: 0.44rem;
                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 2.98rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.32rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }
                }
            }
        }
    .sbcl {
      position: relative;
      margin-top: 0.22rem;
      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.95rem auto 0;
        padding: 0.33rem 0.24rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        
        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.15rem 0.23rem 0.3rem;
          margin-top: 0.5rem;
          position: relative;
          .title {
            font-size: 0.3rem;
            font-weight: bold;
            color: #333333;
          }
          .item {
            margin-top: 0.3rem;
            box-sizing: border-box;
            position: relative;
            padding-left: 0.42rem;
            display: flex;
            line-height: 0.44rem;
            .dot {
              width: 0.39rem;
              height: 0.39rem;
              background-color: #739bfe;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.28rem;
              color: #fff;
              border-radius: 50%;
              position: absolute;
              left: -0.1rem;
              top: 0;
              z-index: 9999;
            }
          }
        }
      }
    }
    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }
        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;
            .line {
              position: absolute;
              width: 0.02rem;
              height: 100%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }
            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }
            .line-top {
              display: flex;
              width: 3.31rem;
              height: 0.49rem;
              background-image: url(../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.08rem;
              .line-num {
                width: 0.39rem;
                height: 0.39rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.14rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }
            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .code {
        width: 1.94rem;
        height: 1.94rem;
      }
      .text {
        height: 1.72rem;
      }
    }
  }
}
</style>
